<script setup lang="ts">
import { useAuth0 } from "@auth0/auth0-vue";

const { loginWithRedirect } = useAuth0();

const signIn = (): void => {
  void loginWithRedirect({ appState: { target: "/" } });
};
</script>

<template>
  <main class="min-h-screen grid place-items-center bg-neutral-50 px-4">
    <div
      class="w-full max-w-md rounded-xl border border-neutral-200 bg-neutral-0 p-8 text-center shadow-sm"
    >
      <img
        src="/ecs-logo.svg"
        alt="ECS Group Command"
        class="mx-auto mb-6 h-9 w-auto"
      >
      <p class="mb-8 text-neutral-500">
        Field inspection, quality, and asset management.
      </p>
      <button
        type="button"
        class="w-full rounded-md bg-brand-primary py-3 font-semibold text-brand-primary-on transition hover:opacity-90"
        @click="signIn"
      >
        Sign in
      </button>
    </div>
  </main>
</template>
